// extracted by mini-css-extract-plugin
export default {"drop":"UploadDropZone_drop__Rh59D","dropOver":"UploadDropZone_dropOver__dRton"};